<template>
	<div class="login qjc-flex">
		<!-- 左半部 -->
		<div class="left qjc-fl qjc-relative">
			<a href="https://main.medinbd.com/" target="_blank"><img class="logo n-expand" src="@/assets/images/logo.png" alt="logo"></a>
			<img class="cover qjc-absolute" v-if="!isShowGif" src="@/assets/images/login-1.gif" alt="登录图">
			<img class="cover qjc-absolute" v-if="isShowGif" src="@/assets/images/login-2.gif" alt="登录图">
		</div>
		
		<!-- 右半部 -->
		<!-- @keyup.enter="submit" -->
		<div  class="right qjc-fr qjc-relative qjc-bg-fff animated fadeInRight">
			<div class="rightFrom">
				<h2 class="qjc-c-dark right-form-title">米因AI服务平台数据后台</h2>
				<el-tabs class="tabs_wrap" v-model="activeName" @tab-click="handleClickTab">
				    <el-tab-pane label="企业用户" name="first">
						<el-form
							class="qjc-absolute"
							:model="login"
							:rules="rules"
							
							ref="login"
						> 
							<el-form-item prop="account" :show-message="false">
								
								<el-input :maxlength="30" type="text" v-model.trim="login.account" placeholder="输入账号名" ref="loginAccount"></el-input>
							
							</el-form-item>
							
							<el-form-item prop="password"  :show-message="false">
								<div class="from-box-li">
								<el-input type="password" :maxlength="30" v-model.trim="login.password" placeholder="请输入登录密码" ref="loginPassword"></el-input>
							</div>
							</el-form-item>
							
							<!-- 人员信息验证 -->
							<h4 class="qjc-c-dark qjc-fts-14 qjc-ftw-500">人员信息验证</h4>
							<el-form-item prop="phone" :show-message="false">
								<div class="from-box-li phone86">
									<!-- <div class="nbr">+86</div> -->
								<el-input 
									type="text" 
									v-model.trim.number="login.phone" 
									placeholder="请输入手机号" 
									@input="phoneMustNumber" 
									ref="loginPhone" 
									v-on:input="loginPhoneJt" 
									class="phone-input"
									:maxlength="20"
									>
									<template slot="prepend">+86</template>
								</el-input>
							</div>
							</el-form-item>
							<el-form-item prop="code" :show-message="false">
								<el-input
									v-model.trim="login.code"
									class="code"
									ref="loginCode"
									placeholder="请输入收到的验证码"
									@input="codeMustNumber"
									maxlength="6"
								>
									<div class="prefix qjc-c-dark qjc-fts-14" slot="prefix">
										验证码
									</div>
									<div class="qjc-fts-14 qjc-c-primary" slot="suffix">
										<span v-if="sending" class="sending">
											{{ countDown }}
											秒后重发
										</span>
										<span v-else @click="sendCode" class="send-code" :class="{'on':loginYzmJt}">{{ loginhqyzm }}</span>
									</div>
								</el-input>
							</el-form-item>
							<div class="form-error">
								<p class="error">{{ formError }}</p>
								<p class="formDx">{{ formDx }}</p>
							</div>
							<el-form-item class="agree" prop="agree" :show-message="false">
								<el-checkbox
									v-model="login.agree"
								></el-checkbox>
								<b class="qjc-fts-12 qjc-c-dark"><label @click="login.agree = !login.agree">我已阅读并同意</label><span @click="agreementShow = true" class="qjc-c-primary qjc-ftw-n">《米因AI服务平台数据后台服务协议》</span></b>
							</el-form-item>
							
							<el-form-item>
								<el-button @click="submit" :loading="loging" class="login-btn qjc-wid-100 qjc-fts-18 qjc-ftw-500">登录</el-button>
							</el-form-item>
						</el-form>
					</el-tab-pane>
				    <el-tab-pane label="医生用户" name="second">
						<el-form
							class="qjc-absolute"
							:model="login2"
							:rules="rules2"
							ref="login2"
							:show-message="false"
						> 
							<el-form-item prop="phone">
								<div class="from-box-li phone86">
									
								<el-input
									type="text" 
									v-model.trim.number="login2.phone" 
									placeholder="请输入手机号" 
									@input="phoneMustNumber" 
									ref="login2Phone" 
									v-on:input="login2PhoneJt" 
									class="phone-input"
									:maxlength="20"
									>
									<template slot="prepend">+86</template>
								</el-input>
							</div>
							</el-form-item>
							<el-form-item prop="code" :show-message="false">
								<el-input
									v-model.trim="login2.code"
									class="code"
									placeholder="请输入验证码"
									@input="codeMustNumber"
									ref="login2Code"
									maxlength="6"
								>
									<div class="prefix qjc-c-dark qjc-fts-14" slot="prefix">
										验证码
									</div>
									<div class="qjc-fts-14 qjc-c-primary" slot="suffix">
										<span v-if="sending2" class="sending">
											{{ countDown2 }}
											秒后重发
										</span>
										<span v-else @click="sendCode2" class="send-code" :class="{'on':login2YzmJt}">{{ login2hqyzm }}</span>
									</div>
								</el-input>
							</el-form-item>
							<div class="form-error">
								<p class="error">{{ formError2 }}</p>
								<p class="formDx">{{ formDx2 }}</p>
							</div>
							<el-form-item class="agree" prop="agree">
								<el-checkbox
									v-model="login2.agree"
								></el-checkbox>
								<b class="qjc-fts-12 qjc-c-dark"><label @click="login2.agree = !login2.agree">我已阅读并同意</label><span @click="agreementShow = true" class="qjc-c-primary qjc-ftw-n">《米因AI服务平台数据后台服务协议》</span></b>
							</el-form-item>
							
							<el-form-item>
								<el-button @click="submit2" :loading="loging" class="login-btn qjc-wid-100 qjc-fts-18 qjc-ftw-500">登录</el-button>
							</el-form-item>
						</el-form>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		
		<!-- 米因AI服务平台数据后台服务协议 -->
		<el-dialog
			:visible.sync="agreementShow"
			title="米因AI服务平台企业后台服务协议"
			class="agreement"
			append-to-body		  :close-on-click-modal="false"
		>	
		<div>
			<ul class="qjc-fts-12">
						<li>
			<!--                        <h6>一、特别提示</h6>-->
							<p class="agreement-special">本协议约定米因智慧医疗（MEDINAI&WISEMEDICALLIMITED，以下简称米因）与用户之间关于“米因AI服务平台企业后台”（以下简称“后台”）的权利义务。</p>
							<p>“用户”是指登录、使用本后台的机构，“操作员”是指机构用户指定的、负相关岗位责任的该机构僱员。</p>
							<p>本协议可由米因随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可随时查阅最新版协议条款。在修改协议条款后，如果用户不接受修改后的条款，请立即停止使用后台，用户继续使用后台将被视为接受修改后的协议。</p>
						</li>
						<li>
			<!--                        <h6>二、账号注册</h6>-->
							<p>1.在米因的认可和允许下，用户有权在本后台进行以下的操作：
								<br/><span>（1）个人客户的会员注册、套餐开通；</span>
								<br/><span>（2）查询套餐开通记录；</span>
								<br/><span>（3）查询、调取个人客户的健康大数据体检报告；</span>
								<br/><span>（4）调取个人客户的预约信息；</span>
							</p>
							<p>2.用户在为个人客户进行会员注册和套餐开通操作时，需要得到个人客户的许可，个人客户应当在自主、自愿的前提下将手机接收到的验证码以及个人信息告知用户，并由操作员负责录入并完成相关操作；</p>
							<p>3.操作员有义务准确填写个人客户的姓名、年龄、性别、出生日期等个人信息，并遵照个人客户的意愿选择开通相应的套餐；</p>
							<p>4.用户清楚了解套餐的开通记录将作为米因与用户之间财务结算的主要凭证；</p>
							<p>5.用户有义务保护个人客户的数据隐私，禁止滥用、洩露个人客户的数据，包括但不限于：
								<br/><span>（1）在非客户要求、非必要的情况下随意查阅、打印、分享个人客户的健康大数据体检报告；</span>
								<br/><span>（2）将个人客户的个人信息、健康大数据体检报告内容等洩露给无关人员和机构；</span>
							</p>
							<p>6.因用户及其操作员的不正当使用而导致用户自身的一切损失，米因概不负责；因用户及其操作员的不正当使用而导致米因遭受损失的，米因有权依法进行追究；因用户及其操作员的不正当使用而导致任何违法、违纪、隐私洩露、公共危害等问题发生的，米因有权立刻中止与用户的合作，并在必要时配合有关部门、机构的调查与处理，一切后果由用户承担。
							</p>
							<p>7、用户应充分告知客户并获得用户的认可，米因大数据健康分析及评估产品为基于常规人体数据所做的大数据个人健康风险分析及预测，不涉及任何需专业医疗资质的诊断及处方，所有分析报告、结果及方案等输出内容均为健康咨询相关的参考内容与建议，客户须根据自身情况采用，或进一步咨询专业的医疗人员。</p>
							<p>8、客户通过常规流程接收到大数据分析及预测等报告相关内容时，即视为产品已完成交付，且客户已消费完毕，米因及相关服务平台均不接受任何退款要求及相关申诉。</p>
							
							<p></p>
						</li>
					</ul>
					<div class="modal-action">
						<el-button type="primary" @click="confirmAgree">我 同 意</el-button>
					</div>
		</div>
		
		</el-dialog>
	</div>
</template>

<script>
	// 验证引入
	import { isPhone, pwdReg } from '@/utils'
	
	import { sendSmsV2, login, getDoctorOrder} from '@/utils/axios'
	
	export default{
		name: 'login',
		data() {
			// 验证
			
			
			// 密码
			var pwdVerify = (rule, value, callback) => {
				if(pwdReg(value)){
					callback();
				}else{
					callback(new Error('密码需为两种及以上字符组成'));
				}
			}
			
			// 手机号
			var phoneVerify = (rule, value, callback) => {
				if(isPhone(value)){
					callback();
				}else{
					callback(new Error('手机号格式不正确'));
				}
			}
			
			// 阅读协议
			var agreeVerify = (rule, value, callback) => {
				if(value){
					callback();
				}else{
					callback(new Error('请阅读并同意《米因大数据体检平台数据后台服务协议》'));
				}
			}
			
			return {
				pageMinHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight ,// 页面最小高度为浏览器视口高度
				formError:'',
				formError2:'',
				loginYzmJt:false,
				login2YzmJt:false,
				loginhqyzm:'获取验证码',
				login2hqyzm:'获取验证码',
				formDx:'',
				formDx2:'',
				// 登录表单
				login: {
					account: '',// 账号
					password: '',// 密码
					
					//人员信息
					phone: '',// 手机号
					code: '',// 验证码
					
					agree: false// 是否接受米因协议 
				},
				login2: {
					phone: '',// 手机号
					code: '',// 验证码
					agree: false// 是否接受米因协议 
				},
				activeName: 'first',
				tabIndex: 0,
				// 验证
				rules: {
					account: [
						{ required: true, message: '账号不能为空', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '密码不能为空', trigger: 'blur' },
						// { validator: pwdVerify, trigger: 'blur' }
					],
					phone: [
						{ required: true, message: '请输入手机号码', trigger: 'blur' },
						{ validator: phoneVerify, trigger: 'blur' }
					],
					code: [
						{ required: true, message: '验证码不能为空', trigger: 'blur' },
					],
					agree: [
						{ validator: agreeVerify, trigger: 'change' }
					]
				},
				rules2: {
					phone: [
						{ required: true, message: '请输入手机号码', trigger: 'blur' },
						{ validator: phoneVerify, trigger: 'blur' }
					],
					code: [
						{ required: true, message: '验证码不能为空', trigger: 'blur' },
					],
					agree: [
						{ validator: agreeVerify, trigger: 'change' }
					]
				},
				agreementShow: false ,//米因协议是否显示
				
				//验证码发送
				sending: false ,// 正在发送验证码
				sending2: false ,// 第二个
				countDown: 60 ,//倒计时 单位:s
				countDown2: 60 ,//第二个倒计时倒计时 单位:s
				
				// 登录
				loging: false,// 正在登录
				
				isShowGif: false
			}
		},
		
		beforeCreate() {
			// 已经登录 返回首页
			if(this.$store.state.isLogin){
				this.$router.replace('/')
			}
			
			setTimeout(() => {
				this.isShowGif = true
			}, 8000)
		},
		
		methods: {
			
			confirmAgree(){
				this.login.agree = true 
				this.login2.agree = true
				 this.agreementShow = false
			},

			//监听手机号是否正确
			loginPhoneJt(){
				if(!(/^1[3-9][0-9]\d{8}$/.test(this.login.phone))){
					this.loginYzmJt=false;
					return
				}
				this.loginYzmJt=true;
				this.formError='';
			},

			//监听手机号是否正确2
			login2PhoneJt(){
				if(!(/^1[3-9][0-9]\d{8}$/.test(this.login2.phone))){
					this.login2YzmJt=false;
					return
				}
				this.login2YzmJt=true;
				this.formError='';
			},

			handleClickTab(tab, event) {
				this.tabIndex = tab.index
			},
			// 发送验证码
			sendCode() {
				if(this.login.agree==false){
					this.login.agree==true;
					this.formError='请阅读并同意协议';
					this.formDx='';
					return
				}
				if(this.login.phone==0){
					this.$refs.loginPhone.focus()
					this.formError='请输入手机号码'
					return
				}
				if(!(/^1[3-9][0-9]\d{8}$/.test(this.login.phone))){
					this.$refs.loginPhone.focus()
					this.formError='手机号码格式不正确，请重新输入'
					return
				}
				this.formError=''
				this.$refs.login.validateField(['phone'], (err) => {
					if(!err){
						this.sending = true;
						this.countDown = 60;//重置时间
						sendSmsV2({
							mobile: this.login.phone,
							country_code: '86'
						}).then(res => {
							if(res.code == 200){
								var timer = setInterval(() => {
									if(this.countDown > 0){
										--this.countDown;
									}else{
										clearInterval(timer);
										this.sending = false;
									}
								},1000);
								this.loginhqyzm='重新发送';
								this.formDx='短信验证码已发送，可能会有延后，请耐心等待';
							}else{
								this.sending = false;
								this.formError=res.msg;
							}
						});
					}
				})
			},

			// 发送验证码2
			sendCode2() {
				if(this.login2.agree==false){
					this.login2.agree==true;
					this.formError2='请阅读并同意协议';
					this.formDx2='';
					return
				}
				if(this.login2.phone==0){
					this.$refs.login2Phone.focus()
					this.formError2='请输入手机号码'
					return
				}
				if(!(/^1[3-9][0-9]\d{8}$/.test(this.login2.phone))){
					this.$refs.login2Phone.focus()
					this.formError2='手机号码格式不正确，请重新输入'
					return
				}
				this.formError2='';
				this.$refs.login2.validateField(['phone'], (err) => {
	if(!err){
		this.sending2 = true;
		this.countDown2 = 60;//重置时间
		sendSmsV2({
			mobile: this.login.phone,
			country_code: '86'
		}).then(res => {
			if(res.status == 1){
				var timer = setInterval(() => {
					if(this.countDown2 > 0){
						--this.countDown2;
					}else{
						clearInterval(timer);
						this.sending2 = false;
					}
				},1000);
				this.login2hqyzm='重新发送';
				this.formDx2='短信验证码已发送，可能会有延后，请耐心等待';
			}else{
				this.sending2 = false;
				this.formError2=res.msg;
			}
		});
	}
})
},
			
			//登录
			submit() {
				const that = this
				if(this.login.account==0){
					this.$refs.loginAccount.focus()
					this.formError='请输入账号名'
					return
				}
				if(this.login.password==0){
					this.$refs.loginPassword.focus()
					this.formError='请输入密码'
					return
				}
				if(this.login.phone==0){
					this.$refs.loginPhone.focus()
					this.formError='请输入手机号码'
					return
				}
				if(!(/^1[3-9][0-9]\d{8}$/.test(this.login.phone))){
					this.$refs.loginPhone.focus()
					this.formError='手机号码格式不正确，请重新输入'
					return
				}
				if(this.login.agree==false){
					this.login.agree==true;
					this.formError='请阅读并同意协议'
					return
				}
				if(this.login.code==0){
					this.$refs.loginCode.focus()
					this.formError='请输入短信验证码';
					this.formDx='';
					return
				}
				this.formError='';
				this.$refs.login.validate((isSuc, obj) => {
					if(isSuc){
						this.loging = true;//正在请求 按钮loading
						login({
							account: this.login.account,
							password: this.login.password,
							mobile: this.login.phone,
							code: this.login.code
						}).then(res => {
							
							if(res.code == 200){
								this.loging = false;
								let data = JSON.parse(window.atob(res.data))
								this.$store.dispatch('login',data.access_token);
								
								localStorage.setItem('mobile', this.login.phone);
								// 存储用户信息
								localStorage.setItem('userInfo', JSON.stringify(data));
								
								sessionStorage.clear()
								let toUrl = this.$route.query.toUrl;
								// .catch为vue3改为promise后可能报错
								//根据账号写死语言为 zh-TW 
								if(that.login.account === 'medintw'){
									sessionStorage.setItem("theLanguage", 'zh-TW')
									setTimeout(() => {
										location.reload()// 刷新当前页面
									},1000)
								}
								
								this.$router.replace(toUrl?toUrl:'/').then(() => {
								}).catch(err => {
									
								});
							}else{
								this.loging = false;
								this.formError=res.msg;
								this.formDx='';
							}
							
						});
					}
				});
			},
			submit2() {

				if(this.login2.phone==0){
					this.$refs.login2Phone.focus()
					this.formError2='请输入手机号码'
					return
				}
				if(!(/^1[3-9][0-9]\d{8}$/.test(this.login2.phone))){
					this.$refs.login2Phone.focus()
					this.formError2='请输入正确手机号'
					return
				}
				if(this.login2.agree==false){
					this.login2.agree==true;
					this.formError2='请阅读并同意协议'
					return
				}
				if(this.login2.code==0){
					this.$refs.login2Code.focus()
					this.formError2='验证码不能为空';
					this.formDx2='';
					return
				}
				this.formError2=''


				this.$refs.login2.validate((isSuc, obj) => {
					if(isSuc){
						this.loging = true;//正在请求 按钮loading
						
						login({
							type: 1,
							mobile: this.login2.phone,
							code: this.login2.code
						}).then(res => {
							
							if(res.code == 200){
								this.loging = false;
								let data = JSON.parse(window.atob(res.data))
								this.$store.dispatch('login',data.access_token);
								
								localStorage.setItem('mobile', this.login2.phone);
								// 存储用户信息
								localStorage.setItem('userInfo', JSON.stringify(data));
								
								sessionStorage.clear()
								let toUrl = this.$route.query.toUrl;
								// .catch为vue3改为promise后可能报错
								this.$router.replace(toUrl?toUrl:'/').catch(err => {
									
								});
							}else{
								this.loging = false;
								this.formError2=res.msg;
								this.formDx2='';
							}
							
						});
					}
				});
			},
			
			//必须输入数字
			phoneMustNumber(value) {//手机号
				//this.login.phone = value.replace(/\D/g,'');
			},
			codeMustNumber(value) {//验证码
				//this.login.code = value.replace(/\D/g,'');
			}
		}
	}
</script>

<style scoped>
	
	
	
	
	/* safari光标错位 */
	.right .el-input >>> .el-input__inner{
		height: 33px;
		line-height: 22px;
		border-radius: 8px;
		border: none;
		color: #333;
		border-bottom: 1px solid #DCDFE6;
		border-radius: 0;
		padding-left:0 ;
	}
	.right .el-input >>> .el-input-group__prepend{border: none;border-radius: 0;padding: 0 ;height: 33px;background: none;}
	.right .el-input >>> .el-input__inner:hover{
		border-bottom: 1px solid #6681FA;
	}
	.right .el-input >>> .el-form-item__error{line-height: 21px;color: red;}
	.account >>> .el-input__inner,
	.password >>> .el-input__inner{
		padding-left: 60px;
	}
	.phone >>> .el-input__inner,
	.code >>> .el-input__inner{
		padding-left: 74px;
	}
	
	.phone-input >>> .el-input-group__prepend{
		height: 33px ;
		line-height: 33px;
	}
	
	.phone-input {
		border-bottom:1px solid #DCDFE6;
	}
	.phone-input:hover {
		border-bottom:1px solid #6681FA;
	}
	
	.phone-input >>> .el-input__inner {
		border:none !important;
		padding-left: 8px !important;
	}
	
	/* 协议 */
	.agreement >>> .el-dialog__header{
		background-color: #e7e9ee;
	}
	.agreement >>> .el-dialog__title{
		font-size: 16px;
	}
	.right >>> .el-tabs__nav-wrap::after {
		background-color: #fff;
	}
	.right >>> .el-tabs__header{
		margin-bottom: 30px;
	}
	.right >>> .el-tabs__item {
		font-size: 18px;
	}
	.right >>> .el-tabs__content {
		overflow: inherit;
	}
</style>
<style lang="scss" scoped>
	
	
	.modal-action{
		width: 100%;
		display:flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		
	}
	
	.right{
	.phoneTo{display: none;line-height: 54px;top:0;left: 0;}
	//.phoneIpt .el-input__inner{padding-left: 50px;}
	

}
	.login{
		
		height: 100%;
		position: fixed;
		width: 100%;
		
		.left{
			width: 50%;
			height: 100%;
			// background:linear-gradient(180deg,rgba(250,250,252,1) 0%,rgba(240,242,250,1) 100%);
			background:#F1F1F5;
			
			.logo{
				width: 141px;
				position: absolute;
				z-index: 1;
				left:30px;
				top:30px;
			}
			// .cover{
			// 	top: 50%;
			// 	left: 50%;
			// 	transform: translate(-50%,-50%);
			// 	width: 683px;
			// 	height: 411px;
			// }
			.cover{
				top: 50%;
				left: 50%;
				transform: translate(-50%,-50%);
				// width: 50%;
				max-width: 880px;
				min-width: 880px;
				height: 732px;
			}
		}
		
		.right{
			// width: 42.222%;
			flex: 1;
			width: 50%;
			height: 100%;
			overflow-y: auto;
			position: relative;
			z-index: 0;
			.rightFrom{
				width: 400px;position: absolute;top:50%;left: 50%;margin: -275px 0 0 -200px;
			}
			
			
			.right-form-title{
				width: 100%;
				text-align: center;
			}
			
			h2{
				margin-bottom: 28px;
			}
			h4{
				margin: 24px 0 12px;
				font-size: 15px;
				font-weight: bold;
			}
			
			.el-form{
				// top: 50%;
				// left: 50%;
				width: 400px;
				// transform: translate(-50%,-50%);
				
				.el-form-item{
					margin-bottom: 0px;
					
					.el-input{
						font-size: 14px;
						
						.prefix{
							padding: 0 16px;
							line-height: 54px;
							display: none;
						}
						span{
							
							line-height: 54px;
						}
						.send-code{
							cursor: pointer;
						}
						.sending{
							color: #999;
							padding-right: 0;
							border-left:1px solid #999 ;
							padding-left:10px;
						}
					}
					&.agree{
						b{
							font-weight: 300;
							margin-left: 6px;
						}
						span{
							cursor: pointer;
						}
					}
					.login-btn{
						height: 48px;
					}
				}
			}
		}
		
		.agreement{
			ul{
				color: #777f8f;
				line-height: 24px;
			}
		}
	}
	.animated {
	-webkit-animation-duration: 0.5s;
	animation-duration: 0.5s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both
}
@-webkit-keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translateX(20px);
		transform: translateX(20px)
	}
	100% {
		opacity: 1;
		-webkit-transform: translateX(0);
		transform: translateX(0)
	}
}

@keyframes fadeInRight {
	0% {
		opacity: 0;
		-webkit-transform: translateX(20px);
		-ms-transform: translateX(20px);
		transform: translateX(20px)
	}
	100% {
		opacity: 1;
		-webkit-transform: translateX(0);
		-ms-transform: translateX(0);
		transform: translateX(0)
	}
}

.fadeInRight {
	-webkit-animation-name: fadeInRight;
	animation-name: fadeInRight
}
@media screen and (max-width: 1024px) {
	.login .left{display: none !important;}
	.login .right{width: 100%;}
	.login .right .rightFrom{position: relative;top: 0;left: 0;margin: 100px auto;}
}
.n-expand{transition:all .3s ease;-webkit-transition:all .3s ease;-moz-transition:all .3s ease;-ms-transition:all .3s ease;-o-transition:all .3s ease;-webkit-backface-visibility:hidden}
.n-expand:hover{transform:scale(1.05, 1.05);-moz-transform:scale(1.05, 1.05);-webkit-transform:scale(1.05, 1.05);-o-transform:scale(1.05, 1.05)}
.from-box-li{position: relative;}
.from-box-li input{border: none;border-bottom: 1px solid #d7d8d9;height: 33px;width: 100%;outline: none;caret-color: #6681FA;color: #333;margin-bottom: 15px;}
.from-box-li input:hover{border-bottom: 1px solid #6681FA;}
.form-error{height: 50px;line-height: 22px;font-size: 14px;}
.form-error .error{color: red;}
.form-error .formDx{color: #333;}
.from-box-li.phone86 .nbr{position: absolute;height: 100%;top:0;left: 0;color: #999;}
.from-box-li.phone86 input{text-indent: 2.5em;}
.send-code{color:#999;border-left:1px solid #999;padding-left: 10px;line-height: 33px;}
.qjc-fts-14.qjc-c-primary{line-height: 33px;height: 33px;position: absolute;right: 0;top: -8px;width: 120px;padding-right: 0;text-align: right;}
.send-code.on{color: #6681FA;}
</style>
